
if (typeof window == 'undefined') {
    var ContentServerHelper = require("./nodeContentServerHelper");
} else {
    var ContentServerHelper = require("./contentServerHelper");
}
var logError = require('./error');

var ContentServerHandler = {};

ContentServerHandler.init = function(session) {
    ContentServerHelper.session = session;
}

// This file exists as a (global) place for the circuits editors to use to make direct CS calls when they need to.
// It will also handle throwing the errors, so that the various places that make these calls do not have to.
// This file can have lib-core dependancies, it is intented as a circuits specific wrapper for the calls in the ContentServerHelper (a shared file)
ContentServerHandler.csRequest = function(requestMethod, requestURL, requestHeaders, obj, sync, jsonResponseExpected, isFormData, contextStr, errorDegree, errorInfo) {
    var self = this;
    if(jsonResponseExpected === undefined) jsonResponseExpected = true;
    var data;
    if(obj) {
        if(isFormData || (typeof FormData !== 'undefined' && obj instanceof FormData)) {
            data = obj;
        } else {
            data = JSON.stringify(obj);
        }
    }

    if(sync){
          try {
              var res = ContentServerHelper.request(requestMethod, requestURL, requestHeaders, data, sync, jsonResponseExpected);
          } catch(err) {
              logError("Content Server Handler", err, errorDegree, contextStr, false, errorInfo);
              throw err;
          }
          return res;
    } else {
          return ContentServerHelper.request(requestMethod, requestURL, requestHeaders, data, sync, jsonResponseExpected)
          .catch(function(error){
                logError("Content Server Handler", error, errorDegree, contextStr, false, errorInfo);
                throw error;
          })
    }
};

module.exports = ContentServerHandler;